import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { BrandLogo, COMPANY, FOOTER_COLUMNS, SOCIAL } from './brand';

const linkSx = {
  display: 'block', color: 'rgba(255,255,255,0.62)', textDecoration: 'none', fontSize: 14, lineHeight: 2,
  '&:hover': { color: '#fff' },
};

const SITE_LINKS = [
  { label: 'Templates', to: '/templates' },
  { label: 'Features', to: '/#features' },
  { label: 'Pricing', to: '/#pricing' },
  { label: 'Site Builder', href: 'https://builder.anainfo.ai' },
  { label: 'Admin login', to: '/login' },
];

export const SocialIcons = () => (
  <Box aria-label="AnAInfo on social media" sx={{ display: 'flex', gap: 1.25 }}>
    {SOCIAL.map(s => (
      <Box key={s.label} component="a" href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} title={s.label}
        sx={{
          width: 40, height: 40, borderRadius: '50%', display: 'grid', placeItems: 'center', color: '#fff',
          bgcolor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.14)', transition: 'all .2s',
          '&:hover': { bgcolor: s.color, borderColor: s.color, transform: 'translateY(-2px)' },
        }}>
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d={s.d} /></svg>
      </Box>
    ))}
  </Box>
);

// Footer with the same company details, columns and socials as anainfo.com,
// plus this site's own links.
const SiteFooter = () => (
  <Box component="footer" sx={{ bgcolor: '#100d24', color: 'rgba(255,255,255,0.7)', px: { xs: 2, md: 4 }, pt: 7, pb: { xs: 12, sm: 5 } }}>
    <Box sx={{ maxWidth: 1240, mx: 'auto' }}>
      <Box sx={{
        display: 'grid', gap: { xs: 4, md: 4 },
        gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(5, 1fr)', lg: '1.4fr repeat(5, 1fr)' },
      }}>
        <Box sx={{ gridColumn: { xs: '1 / -1', lg: 'auto' } }}>
          <BrandLogo light />
          <Typography sx={{ mt: 2, fontSize: 14, lineHeight: 1.9 }}>
            <Box component="a" href={COMPANY.phoneHref} sx={{ ...linkSx, display: 'inline', lineHeight: 'inherit' }}>{COMPANY.phone}</Box><br />
            <Box component="a" href={`mailto:${COMPANY.email}`} sx={{ ...linkSx, display: 'inline', lineHeight: 'inherit' }}>{COMPANY.email}</Box><br />
            {COMPANY.address}
          </Typography>
        </Box>
        {FOOTER_COLUMNS.map(col => (
          <Box key={col.title} component="nav" aria-label={col.title}>
            <Typography component="h3" sx={{ color: '#fff', fontWeight: 600, fontSize: 15, mb: 1.25 }}>{col.title}</Typography>
            {col.links.map(l => <Box key={l.label} component="a" href={l.href} sx={linkSx}>{l.label}</Box>)}
          </Box>
        ))}
        <Box component="nav" aria-label="Anainfo.ai">
          <Typography component="h3" sx={{ color: '#fff', fontWeight: 600, fontSize: 15, mb: 1.25 }}>Anainfo.ai</Typography>
          {SITE_LINKS.map(l => l.to
            ? <Box key={l.label} component={RouterLink} to={l.to} sx={linkSx}>{l.label}</Box>
            : <Box key={l.label} component="a" href={l.href} sx={linkSx}>{l.label}</Box>)}
        </Box>
      </Box>
      <Box sx={{ mt: 5 }}><SocialIcons /></Box>
      <Typography sx={{ mt: 3, pt: 3, borderTop: '1px solid rgba(255,255,255,0.08)', fontSize: 13.5, color: 'rgba(255,255,255,0.5)' }}>
        © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
      </Typography>
    </Box>
  </Box>
);

export default SiteFooter;
